import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import { useVideoLibraryActions } from 'src/store/videoLibrary/actions';
import { useVideosActions } from 'src/store/videos/actions';
import { useCourseActions } from 'src/store/course/actions';
interface IProps {
    contentId: string;
    contentType: number;
    contentName: string
}
const DeleteContentModal: React.FC<IProps> = ({ contentId, contentType, contentName }) => {
    const dispatch = useDispatch();
    const courseAction = useCourseActions(dispatch);
    const videoActions = useVideosActions(dispatch);
    const ref = useRef<HTMLButtonElement>(null);
    const { isVideoDeleted, isChapterDeleted, isCheckpointDeleted } = useSelector((state: RootState) => {
        return {
            isVideoDeleted: state.videos.isVideoDeleted,
            isChapterDeleted: state.course.isChapterDeleted,
            isCheckpointDeleted: state.course.isCheckpointDeleted
        };
    });
    const handleDeleteClick = (contentId: string, contentType: number) => {
        if (contentType == 3) {
            courseAction.deleteCheckpointRequest(contentId)
        } else if (contentType == 4) {
            courseAction.deleteChapterRequest(contentId)
        } else {
            videoActions.deleteVideoRequest(contentId)
        }
    }
    useEffect(() => {
        if (isVideoDeleted || isChapterDeleted || isCheckpointDeleted) {
            if (ref.current) {
                ref.current.click();
            }
        }
    }, [isVideoDeleted, isChapterDeleted, isCheckpointDeleted]);
    return (
        <div>
            <div className="modal fade" id="deleteContentModal" aria-labelledby="deleteContentModal" aria-hidden="true">
                <div className="modal-dialog relative w-auto pointer-events-none max-w-xl">
                    <div className="modal-content">
                        <div className="relative modal-header flex flex-shrink-0 items-center justify-between p-4 rounded-t-md">
                            {/* <i className="fa fa-trash-o  modal-icon"></i> */}
                            <h5
                                className="text-xl font-semibold leading-normal text-center w-full"
                                id="deleteContentModal">
                                Delete Content
                            </h5>

                            <button
                                ref={ref}
                                type="button"
                                className="dismiss-btn"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body relative py-4 px-10">
                            <form>
                                <div className={`form-group mb-3`}>
                                    <label className="block text-sm font-medium mb-1 text-center">
                                        Are you sure you want to delete <span className='font-bold'>{contentName}</span>?
                                    </label>
                                </div>

                                <div className="modal-footer mt-5 flex flex-shrink-0 flex-wrap items-center justify-center px-4 pb-2 rounded-b-md">
                                    <button
                                        onClick={() => handleDeleteClick(contentId, contentType)}
                                        type="button"
                                        className="px-6 btn-primary w-auto whitespace-nowrap mr-2 ml-0 mt-0">
                                        Delete
                                    </button>
                                    <button
                                        type="button"
                                        className="mx-0 px-6 btn-primary discard-btn w-auto whitespace-nowrap mt-0"
                                        data-bs-dismiss="modal">
                                        Close
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteContentModal;
